import { useCallback, useContext } from 'react';

import { getKameleoonFeatureFlag } from 'PublicApis';

import { ConfigContext } from 'Context/config';

import { FeatureFlagName } from '../featureFlags';

type GetFeatureFlagsArgs<T extends FeatureFlagName> = {
  readonly flagName: T;
  readonly pathname: string;
  readonly userId?: string;
}

export const useKameleoonFeatureFlags = () => {
  const { configState: { kameleoonFeatureFlags } } = useContext(ConfigContext);

  const getFeatureFlag = useCallback(
    async <T extends FeatureFlagName>({
      flagName,
      pathname,
      userId,
    }: GetFeatureFlagsArgs<T>) =>
      getKameleoonFeatureFlag({ flagName, pathname, userId }).catch((err) => {
        window?.Sentry?.captureException?.(new Error(err), {
          level: 'error',
          tags: {
            fetch: 'Kameleoon feature flag',
          },
        });
        return null;
      }),
    [],
  );

  return { featureFlags: kameleoonFeatureFlags, getFeatureFlag };
};
